export default "__VITE_ASSET__ab5a68d7__"